import type { EntityAdapter, EntityState } from '@ngrx/entity';
import { createEntityAdapter } from '@ngrx/entity';
import { on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';

import type { NormalizedTabEntity } from '@web/types';

import TabsActions from './tabs.actions';

export const TAB_FEATURE_KEY = 'tabs';

export type TabsState = EntityState<NormalizedTabEntity>;

export const tabsAdapter: EntityAdapter<NormalizedTabEntity> = createEntityAdapter<NormalizedTabEntity>();

export const tabsReducer = createImmerReducer<TabsState>(
    tabsAdapter.getInitialState(),
    on(TabsActions.init, (state: TabsState, { entities }) => tabsAdapter.setAll(entities, state)),
    on(TabsActions.addMany, (state: TabsState, { entities }) => {
        return tabsAdapter.addMany(entities, state);
    }),
    on(TabsActions.added, TabsActions.created, TabsActions.copied, (state: TabsState, { entity }) => {
        return tabsAdapter.addOne(entity, state);
    }),
    on(TabsActions.removed, (state: TabsState, { entity }) => {
        return tabsAdapter.removeOne(entity.id, state);
    }),
    on(TabsActions.updateProperties, (state: TabsState, { update }) => {
        const tab = state.entities[update.id];
        if (!tab) {
            return state;
        }

        tab.props = { ...tab.props, ...update.changes.props };

        if (update.changes.children) {
            tab.children = update.changes.children;
        }

        return state;
    }),
    on(TabsActions.appendChild, (state: TabsState, { entityId, childId, order }) => {
        const entity = state.entities[entityId];
        if (!entity) {
            return state;
        }

        const insertIndex = typeof order === 'number' && order >= 0 ? order : entity.children.length;
        entity.children.splice(insertIndex, 0, childId);
        return state;
    })
);
